import React from 'react'
import { observer } from 'mobx-react-lite'
import env from './../../environments/environment'
import PLACEHOLDER from './../../assets/images/user_placeholder.png'
import { useBreakTheBarSetting } from './../../components/shared/useBreakTheBarSetting'

const ELITE_AGENCY_TEAM_LOGO_SRC = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/{ELITE_AGENCY_TEAM}?alt=media`

function getTeamLogo(eliteAgencyTeam, strict = false) {
  eliteAgencyTeam = eliteAgencyTeam
    ? typeof eliteAgencyTeam === 'string'
      ? { team_logo: eliteAgencyTeam }
      : eliteAgencyTeam
    : false

  if (eliteAgencyTeam) {
    if (typeof eliteAgencyTeam === 'object' && eliteAgencyTeam?.team_logo)
      return ELITE_AGENCY_TEAM_LOGO_SRC.replace(
        '{ELITE_AGENCY_TEAM}',
        encodeURIComponent(decodeURIComponent(eliteAgencyTeam.team_logo))
      )
    if (typeof eliteAgencyTeam === 'string' && eliteAgencyTeam)
      return ELITE_AGENCY_TEAM_LOGO_SRC.replace(
        '{ELITE_AGENCY_TEAM}',
        encodeURIComponent(decodeURIComponent(eliteAgencyTeam))
      )
  }

  if (strict) return false

  return PLACEHOLDER
}

function _renderer({ EliteAgencyTeam, className, mustBreakBar, totalPoints, isVisible, threshold }) {
  const hasBrokenBar = mustBreakBar === true ? totalPoints >= threshold : isVisible
  isVisible = typeof isVisible === 'undefined' ? !!(!mustBreakBar || (mustBreakBar && hasBrokenBar)) : isVisible

  if (typeof EliteAgencyTeam === 'string')
    return (
      <div className='elite-agency-team-logo'>
        {isVisible && !!(!mustBreakBar || (mustBreakBar && hasBrokenBar)) ? (
          <img alt={'Elite Agency Team'} className={className} src={getTeamLogo(EliteAgencyTeam)} />
        ) : (
          <></>
        )}
      </div>
    )

  if (EliteAgencyTeam && typeof EliteAgencyTeam === 'object') {
    if (EliteAgencyTeam?.get && typeof EliteAgencyTeam.get === 'function')
      return (
        <div className='elite-agency-team-logo'>
          {isVisible && !!(!mustBreakBar || (mustBreakBar && hasBrokenBar)) ? (
            <img
              className={className}
              alt={EliteAgencyTeam.get('team_name') || 'Elite Agency Team'}
              src={getTeamLogo(EliteAgencyTeam.get('team_logo'))}
            />
          ) : (
            <></>
          )}
        </div>
      )

    return (
      <div className='elite-agency-team-logo'>
        {isVisible && !!(!mustBreakBar || (mustBreakBar && hasBrokenBar)) ? (
          <img
            className={className}
            alt={EliteAgencyTeam?.name || EliteAgencyTeam?.team_name || 'Elite Agency Team'}
            src={getTeamLogo(EliteAgencyTeam?.team_logo || EliteAgencyTeam?.pic || null)}
          />
        ) : (
          <></>
        )}
      </div>
    )
  }

  return (
    <div className='elite-agency-team-logo'>
      {isVisible && !!(!mustBreakBar || (mustBreakBar && hasBrokenBar)) ? (
        <img square alt={'Elite Agency Team'} className={className} src={getTeamLogo()} />
      ) : (
        <></>
      )}
    </div>
  )
}

function renderTeamLogo(EliteAgencyTeam) {
  return _renderer({
    EliteAgencyTeam,
    className: EliteAgencyTeam.className || '',
    isVisible: true,
  })
}

const TeamLogo = observer(({ team }) => {
  // get the threshold to evaluate agent performance against.
  const { threshold } = useBreakTheBarSetting('elite_agency_team'),
    { team_logo, team_name, className, mustBreakBar, totalPoints } = team || {}

  return _renderer({
    EliteAgencyTeam: team,
    team_logo,
    team_name,
    className,
    mustBreakBar,
    totalPoints,
    threshold,
  })
})

export { getTeamLogo, renderTeamLogo, TeamLogo }
